export const ASSESSMENT_STATUS = {
  SCHEDULED: 'scheduled',
  RECENT: 'recent',
  ONGOING: 'ongoing',
  LAST_DAY: 'last_day',
  CLOSED: 'closed',
  PRINTED: 'printed',
  BLOCKED: 'blocked',
};

export const STATUS_CONFIG = {
  [ASSESSMENT_STATUS.SCHEDULED]: { label: 'Agendada', color: '#1565c0', backgroundColor: 'rgba(30, 136, 229, 0.14)' },
  [ASSESSMENT_STATUS.RECENT]: { label: 'Recém-criada', color: '#616161', backgroundColor: 'rgba(97, 97, 97, 0.12)' },
  [ASSESSMENT_STATUS.ONGOING]: { label: 'Em andamento', color: '#2e7d32', backgroundColor: 'rgba(76, 175, 80, 0.18)' },
  [ASSESSMENT_STATUS.LAST_DAY]: { label: 'Último dia', color: '#e65100', backgroundColor: 'rgba(255, 152, 0, 0.18)' },
  [ASSESSMENT_STATUS.CLOSED]: { label: 'Encerrada', color: '#616161', backgroundColor: 'rgba(97, 97, 97, 0.12)' },
  [ASSESSMENT_STATUS.PRINTED]: { label: 'Disponível', color: '#2e7d32', backgroundColor: 'rgba(129, 199, 132, 0.28)' },
  [ASSESSMENT_STATUS.BLOCKED]: { label: 'Bloqueado', color: '#616161', backgroundColor: 'rgba(97, 97, 97, 0.12)' },
};

const RECENT_THRESHOLD_DAYS = 2;

// Derived purely from fields already returned by the assessment-availability list
// endpoint (start/end/assessmentType/disabled/createdAt) — no new backend calls.
export function getAssessmentStatus(record) {
  if (record.disabled) return ASSESSMENT_STATUS.BLOCKED;
  if (record.assessmentType === 'printed') return ASSESSMENT_STATUS.PRINTED;
  if (!record.start || !record.end) return ASSESSMENT_STATUS.SCHEDULED;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const start = new Date(record.start.substring(0, 10) + 'T03:00:00Z');
  const end = new Date(record.end.substring(0, 10) + 'T03:00:00Z');

  if (today < start) return ASSESSMENT_STATUS.SCHEDULED;
  if (today > end) return ASSESSMENT_STATUS.CLOSED;
  if (today.getTime() === end.getTime()) return ASSESSMENT_STATUS.LAST_DAY;

  if (record.createdAt) {
    const createdAt = new Date(record.createdAt);
    const daysSinceCreated = (today - createdAt) / (1000 * 60 * 60 * 24);
    if (daysSinceCreated <= RECENT_THRESHOLD_DAYS) return ASSESSMENT_STATUS.RECENT;
  }

  return ASSESSMENT_STATUS.ONGOING;
}

export function getStatusConfig(status) {
  return STATUS_CONFIG[status] || STATUS_CONFIG[ASSESSMENT_STATUS.CLOSED];
}

// Correction progress of a printed assessment, derived from its students' result items
// (see `usePrintedAssessmentCorrections`) — mirrors the per-student status already used
// on the results page, where `status === 'finished'` means the sheet has been corrected.
export const PRINTED_CORRECTION_STATUS = {
  AWAITING_CORRECTION: 'awaiting_correction',
  CORRECTING: 'correcting',
  COMPLETED: 'completed',
};

export const PRINTED_CORRECTION_STATUS_CONFIG = {
  [PRINTED_CORRECTION_STATUS.COMPLETED]: {
    label: 'Concluída', color: '#2e7d32', backgroundColor: 'rgba(76, 175, 80, 0.18)', variant: 'default',
  },
  [PRINTED_CORRECTION_STATUS.CORRECTING]: {
    label: 'Em correção', color: '#e65100', backgroundColor: 'rgba(255, 152, 0, 0.18)', variant: 'default',
  },
  [PRINTED_CORRECTION_STATUS.AWAITING_CORRECTION]: {
    label: 'Aguardando correção', color: '#1565c0', backgroundColor: 'transparent', variant: 'outlined',
  },
};

export function getPrintedCorrectionStatus({ correctedCount, totalCount }) {
  if (totalCount > 0 && correctedCount === totalCount) return PRINTED_CORRECTION_STATUS.COMPLETED;
  if (correctedCount > 0) return PRINTED_CORRECTION_STATUS.CORRECTING;
  return PRINTED_CORRECTION_STATUS.AWAITING_CORRECTION;
}

export function getPrintedCorrectionStatusConfig(status) {
  return (
    PRINTED_CORRECTION_STATUS_CONFIG[status]
    || PRINTED_CORRECTION_STATUS_CONFIG[PRINTED_CORRECTION_STATUS.AWAITING_CORRECTION]
  );
}